import styled from "styled-components";

const fontPrices = "Open Sans";
const paymentStatusActionFont = "'Poppins', 'Open Sans', sans-serif";

const getThemeOverlayColor = (color?: string) => {
    if (!color) return 'rgba(37, 37, 163, 0.12)';

    const value = color.trim();
    const shortHex = /^#([0-9a-f]{3})$/i.exec(value);
    if (shortHex) {
        const [r, g, b] = shortHex[1].split('').map((channel) => parseInt(channel + channel, 16));
        return `rgba(${r}, ${g}, ${b}, 0.12)`;
    }

    const longHex = /^#([0-9a-f]{6})$/i.exec(value);
    if (longHex) {
        const normalized = longHex[1];
        const r = parseInt(normalized.slice(0, 2), 16);
        const g = parseInt(normalized.slice(2, 4), 16);
        const b = parseInt(normalized.slice(4, 6), 16);
        return `rgba(${r}, ${g}, ${b}, 0.12)`;
    }

    const rgb = /^rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/i.exec(value);
    if (rgb) {
        return `rgba(${rgb[1]}, ${rgb[2]}, ${rgb[3]}, 0.12)`;
    }

    const rgba = /^rgba\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*[\d.]+\s*\)$/i.exec(value);
    if (rgba) {
        return `rgba(${rgba[1]}, ${rgba[2]}, ${rgba[3]}, 0.12)`;
    }

    return 'rgba(37, 37, 163, 0.12)';
};

const InfoCardContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    font-size: 0.8rem;
    /* height: 90vh; */
    * {
        box-sizing: border-box;
    }
    
    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
        flex-direction: column;
        font-size: 1rem;
        word-break: break-all;
    }

    > div {
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-items: center;
        flex: 1;
        height: auto;
    }
`;

const InfoCard = styled.div`
    background-color: #f6f6f6;
    width: 80%;
    overflow: hidden;
    margin: 0.8rem 1rem;
    border-radius: 3px;
    padding: 0.8rem 0.5rem;
    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
        width: 90%;
    }
`;

const PurchaseResumeInfo = styled(InfoCard)`
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    & * {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin: 0.25rem 0.5rem;
        font-weight: 500;
        @media (max-width: ${props => props.theme.breakpoints.md}) {
            margin: 0.5vh 0.5vh;
        }
    }
    #last {
        border-top: 1px solid #E2E2E2;
    }
`;

const PaymentInfo = styled(InfoCard)`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    > div:first-child {
        min-width: 30%;
        max-width: 30%;
        display: flex;
        justify-content: center;
        align-items: center;
        svg {
            width: 100%;
        }
    }
`;

const AddressInfo = styled(InfoCard)`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    > div:first-child {
        min-width: 30%;
        max-width: 30%;
        display: flex;
        justify-content: center;
        align-items: center;
        svg {
            width: 100%;
        }
    }
`;

const InvoiceContainer = styled.div`
`;

const ActionsInvoiceContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    flex-direction: row;
    margin: 1rem;
`;

const ActionButton = styled.button`
    border: none;
    background: none;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    outline: none;
    cursor: pointer;
`

const ProductsPurchasedContainer = styled.div`
    max-height: 60vh;
    overflow-y: auto;
    margin-right: 1rem;
    &::-webkit-scrollbar{
        width: 5px;
        
    }
    &::-webkit-scrollbar-thumb {
        border-radius: 2.5px;
        background: #C4C4C4;
    }
    &::-webkit-scrollbar-track {
        border-radius: 2.5px;
        background: #F6F6F6;
    }
    @media (max-width: ${props => props.theme.breakpoints.md}) {
        max-height: 50vh;
        margin-left: 0em;
    }

    @media print {
        margin-top: 10vh;
        height: auto;
        max-height: 1000vh;
        overflow-y: visible;
        page-break-inside: avoid;
    }
`

const ProductPurchasedCard = styled.div`
    display: flex;
    padding: 0.5rem 0.5rem;
    justify-content: flex-start;
    align-items: center;
    margin: 0rem 1rem;
`

const ProductPurchasedImage = styled.img`
    width: 20%;
    border-radius: 8.2px;
    @media (max-width: ${props => props.theme.breakpoints.md}) {
        width: 30%;
    }

`
const CancelButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: none;
    background: none;
    padding: 0;
    text-decoration: underline;
    font-family: ${paymentStatusActionFont};
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;
    text-align: center;
    color: #000000;
    margin: 0 auto;
    cursor: pointer;

    &:hover {
        opacity: 0.85;
    }
`

const ProductPurchasedInfo = styled.div`
    margin-left: 1rem;

    .purchase-detail-product-reference {
        margin-top: 0;
        margin-bottom: 0.4rem;
        font-family: ${fontPrices};
    }
`

const ErrorStateCard = styled.div<{ $accentColor?: string }>`
    position: relative;
    isolation: isolate;
    width: 100%;
    max-width: 944px;
    margin: 0 auto 2rem;
    overflow: visible;

    &::before {
        content: "";
        position: absolute;
        z-index: -1;
        top: -20px;
        left: -14px;
        width: calc(100% + 28px);
        height: 260px;
        background: ${(props) => getThemeOverlayColor(props.$accentColor)};
        border-radius: 27px;
        pointer-events: none;
    }

    @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
        &::before {
            top: -10px;
            left: 0;
            width: 100%;
            height: 180px;
            border-radius: 16px;
            opacity: 0.8;
        }
    }
`

const ErrorStateSurface = styled.div`
    position: relative;
    z-index: 1;
    padding: 1.25rem 1.5rem 1rem;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 5px 14px 20.6px rgba(0, 0, 0, 0.1);

    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
        padding: 1rem;
    }

    @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
        border-radius: 16px;
        box-shadow: 0px 12px 24px rgba(0, 0, 0, 0.1);
    }
`

const ErroContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 30px;
    gap: 14px;
    padding: 1rem 1.5rem 2rem;

    > button:first-child {
        width: auto;
        min-width: 320px;
        max-width: 360px;
        min-height: 67px;
        padding: 20px 32px;
        border-radius: 5px;
        font-family: ${paymentStatusActionFont};
        font-size: 18px;
        font-weight: 700;
        line-height: 27px;
        white-space: nowrap;
    }

    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
        padding: 1rem 1rem 1.5rem;
    }

    @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
        > button:first-child {
            width: 100%;
            min-width: 0;
            max-width: 100%;
            white-space: normal;
        }
    }
`

const PaymentMethodImg = styled.img`

`
const ButtonsActions = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 1rem 2.75rem;
    padding-top: 1%;
    padding-bottom: 2%;

    /* Ambos botones con el mismo ancho e icono alineado al texto */
    > button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
        min-width: 212px;
        padding: 0.5rem 1.5rem;
        font-family: 'Open Sans';
        font-size: 0.9rem;

        /* Contenedor de CustomIcon: evita el espacio de línea bajo el svg */
        > div {
            display: flex;
        }

        /* El icono sigue el color del texto del botón (blanco, y el de la tienda en hover) */
        > div svg path {
            fill: currentColor;
        }
    }
`
 
const DiscountColoredText = styled.span`
    color: #67C940 !important;
    margin: 0 !important;
`

export {
    ActionButton,
    ActionsInvoiceContainer,
    AddressInfo,
    CancelButton,
    ErrorStateCard,
    ErrorStateSurface,
    ErroContainer,
    InfoCardContainer,
    InvoiceContainer,
    PaymentInfo,
    PurchaseResumeInfo,
    ProductsPurchasedContainer,
    ProductPurchasedCard,
    ProductPurchasedImage,
    ProductPurchasedInfo,
    PaymentMethodImg,
    ButtonsActions,
    DiscountColoredText
};
